/***
 * @                  江城子 . 程序员之歌
 * @
 * @              十年生死两茫茫，写程序，到天亮。
 * @                  千行代码，Bug何处藏。
 * @              纵使上线又怎样，朝令改，夕断肠。
 * @
 * @              领导每天新想法，天天改，日日忙。
 * @                  相顾无言，惟有泪千行。
 * @              每晚灯火阑珊处，夜难寐，加班狂。
 * @
 * @
 * @Author: your name
 * @Date: 2022-02-22 14:17:06
 * @LastEditTime: 2022-03-09 09:11:00
 * @LastEditors: your name
 * @Description: 
 * @FilePath: /dangdaihui/src/utils/wxConfig.js
 ***/

import wx from 'weixin-js-sdk' // 引入微信SDK
import { getRequest } from './api'
const sha256 = require("js-sha256").sha256;

function randomString(length) {
  let result = '';
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
 
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
 
  return result;
}
export function initConfig () {
  let url = window.location.href.split('#')[0]

  const now = Date.now(); // 获取当前时间的毫秒数
  const timestampSeconds = Math.floor(now / 1000); // 转换为秒
  const Str =randomString(6)
  const sign = sha256('action=all&&appId=11&&name=jhwb&&nonceStr='+Str+'&&platform=wx&&timestamp='+timestampSeconds+'&&url='+encodeURI(url)+'&&salt=jdzxxx2')

  console.log(333,encodeURI(url));
  
  getRequest("/getJsConfig?url="+encodeURI(url)+'&name=jhwb&action=all',
    {'X-APP-ID':11,
      'X-Platform':'wx',
      'X-Nonce-Str':Str,
      'X-TIMESTAMP':timestampSeconds,
      'X-SIGNATURE':sign

  }).then((res) => {
  
   var  wxdata= JSON.parse(JSON.stringify(res.data.data))
    console.log(wxdata)
    const theurl = new URL(window.location.href);
    const params = new URLSearchParams(theurl.search);
    let id = params.get('id'); // "John"
    
    if (id) {
    }else{
      id=0
    }
    

    const share = {
      title: "金彩出马·新春大吉",
      imgUrl: 'https://zthd.jcy.jinhua.com.cn/jccm/share.jpg',
      link: wxdata.url, // 分享链接
      desc:"金彩云新春特别策划"
    }

    console.log(share);
    // console.log(typeof String(wxdata.timestamp));
    
    wx.config({
      debug: false,
      appId: wxdata.appId,
      timestamp: String(wxdata.timestamp),
      nonceStr: String(wxdata.nonceStr),
      signature: wxdata.signature,
      jsApiList: wxdata.jsApiList
    })

    wx.error(function (res) {
      console.log('验证失败返回的信息:', res)
    })

    wx.checkJsApi({
      jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareAppMessage', 'onMenuShareTimeline'],
      success: function (res) {
        console.log('🚀 ~ file: wxConfig.js ~ line 47 ~ res', res)
        // 以键值对的形式返回，可用的api值true，不可用为false
        // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
      }
    })



   wx.ready(function () {

      // 分享给朋友
      wx.updateAppMessageShareData({
        title: share.title, // 分享标题
        desc: share.desc, // 分享描述
        link: share.link, // 分享链接
        imgUrl: share.imgUrl, // 分享图标
        desc:share.desc,
        success: function () {
          // window.alert('已分享给好友');
          console.log('分享内容', share)

        }
      })

      // 分享到朋友圈
      wx.updateTimelineShareData({
        title: share.title, // 分享标题
        link: share.link, // 分享链接
        imgUrl: share.imgUrl, // 分享图标
        desc:share.desc,
        success: function () {
          // window.alert('已分享到朋友圈');
          console.log('分享内容', share)

        },
      })
      wx.onMenuShareTimeline({
        title: share.title, // 分享标题
        link: share.link, // 分享链接
        imgUrl: share.imgUrl, // 分享图标
        desc:share.desc,
        success: function () {
          // window.alert('已分享到朋友圈');
          console.log('分享内容', share)

        },
      })
      wx.onMenuShareAppMessage({
        title: share.title, // 分享标题
        desc: share.desc, // 分享描述
        link: share.link, // 分享链接
        imgUrl: share.imgUrl, // 分享图标
        desc:share.desc,
        success: function () {
          // window.alert('已分享给好友');
          console.log('分享内容', share)

        }
      });
      
      // wx.onMenuShareTimeline({
      //   title: share.title, // 分享标题
      //   link: share.link, // 分享链接
      //   imgUrl: share.imgUrl, // 分享图标
      //   success: function () {
      //     // 用户点击了分享后执行的回调函数
      //     console.log('分享内容', share)

      //   }
      // })

      // wx.onMenuShareAppMessage({
      //   title: share.title, // 分享标题
      //   link: share.link, // 分享链接
      //   imgUrl: share.imgUrl, // 分享图标
      //   type: '', // 分享类型,music、video或link，不填默认为link
      //   dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
      //   success: function () {
      //     // 用户点击了分享后执行的回调函数
      //     console.log('分享内容', share)
      //   }
      // })

    })
  })
}